interface TrackPoint {
    position: number;
    time: number;
}

class VelocityTracker {
    private track: TrackPoint[] = new Array(10);

    private startIndex = 0;

    public addPosition(position: number) {
        const time = Date.now();
        this.track[this.startIndex] = {
            position,
            time
        };

        this.startIndex = (this.startIndex + 1) % 10;
    }

    public getVelocity(): number {
        const now = Date.now();
        const items = this.track.filter(tp => now - tp.time < 150).sort((a, b) => a.time - b.time);

        if (items.length < 2) {
            return 0;
        }
        const firstItem = items[0];
        const lastItem = items[items.length - 1];

        const deltaV = lastItem.position - firstItem.position;
        const deltaT = lastItem.time - firstItem.time;

        const scale = 1000 / deltaT;

        return deltaV * scale;
    }
}

export default VelocityTracker;
